import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "discourse/templates/hide-modal.hbs" })